/**
 * Kacheln „Nachweisart“ – erster Schritt im Dialog „Nachweis anlegen“.
 *
 * Eine Kachel je Nachweisart, auch ohne Katalogeinträge: Die Kacheln spiegeln die Nachweisarten,
 * nicht den Katalog. Darunter stehen als Beispiele die ersten drei Katalogeinträge der Art in
 * Katalog-Reihenfolge, damit erkennbar ist, was dazugehört (Eiswurf ist ein Gutachten, kein
 * Fachbeitrag).
 */
import { ChoiceTile } from "../../../common/inputs/ChoiceTiles";
import { EvidenceCatalogOption, LookupOption } from "../../../../types";

const EXAMPLE_COUNT = 3;

export function evidenceTypeTiles(
  evidenceTypes: LookupOption[],
  catalog: EvidenceCatalogOption[],
): ChoiceTile[] {
  return evidenceTypes.map((type) => {
    const names = catalog
      .filter((entry) => entry.evidence_type.id === type.id)
      .map((entry) => entry.bezeichnung);
    const examples = names.slice(0, EXAMPLE_COUNT).join(", ");
    return {
      id: type.id,
      title: type.name,
      caption:
        names.length > EXAMPLE_COUNT ? `${examples} …` : examples || undefined,
    };
  });
}
